/* 中文语言配置*/
module.exports = {
  text: '中文',
  base: {
    FullLoaded: '已全部加载！',
    NoData: '暂无数据',
    ScanLoc: '托盘扫码',
    ScanBox: '盘点确认'
  },
  tabbar: {
    Awaiting: '待领取',
    BoxScan: '扫箱',
    ItemScan: '扫双'
  },
  login: {
    messages: {
      userName: '用户名不能为空!',
      password: '密码不能为空！'
    },
    placeholder: {
      userName: '请输入用户名',
      password: '请输入密码'
    },
    button: {
      SignIn: '登录'
    }
  },
  setting: {
    title: '设置',
    menus: {
      DownloadThe: '下载最新版本',
      switchLanguage: '切换语言',
      CurrentVersionNumber: '当前版本号'
    }
  },
  home: {
    menu: {
      Cycle: '盘点',
      Transfer: '移库'
    },
    button: {
      Setting: '设置',
      Quit: '退出'
    }
  },
  Cycle: {
    title: '盘点任务',
    tabbar: {
      Checking: '待盘点',
      ReCheck: '待复盘'
    },
    label: {
      ScanAisle: '扫库位'
    },
    placeholder: {
      ScanAisle: '请扫描库位'
    },
    taskList: {
      CycleNo: '盘点单号',
      CheckAisle: '盘点库位',
      JobType: '任务类型',
      stcheck: '初盘',
      ReCheck: '复盘',
      StartingTime: '任务时间'
    }
  },
  CycleDetails: {
    title: '盘点详情',
    tabbar: {
      ExpectedInfo: '待盘点信息',
      Confirm: '盘点确认'
    },
    tableData: {
      CyclePallet: '盘点托盘',
      QtyExp: '预期数量',
      BoxExp: '预期箱数'
    },
    tableTitle: {

    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/langs/zh.js